<template>
    <div class="o-tiles tiles">
        <div 
            class="tiles__wrapper"
            v-touch:swipe="swipeHandler"
        >
            <div class="tiles__container">
                <button
                    class="tiles__button"
                    type="button"
                    v-for="(button, index) in itemsToShow"
                    :aria-label="ariaLabelTitleButton"
                    :key="index"
                    @click="onCLick(button)"
                >
                    <slot :button="button" />
                </button>
            </div>
        </div>
        <div class="tiles__pagination">
            <span class="tiles__pagination-label">
                {{ $t('ui.page') }}
            </span>
            <button
                type="button"
                class="tiles__pagination-button"
                :aria-label="ariaLabelPrevPage"
                :disabled="disableUp"
                @click="prevPage"
            >
                <svg-icon
                    original
                    name="icons/arrow-up"
                    class="tiles__pagination-icon"
                />
            </button>
            <span class="tiles__pagination-value">
                <span>{{ pageNumber + 1 }} {{ $t('o-tiles_pagination-value') }} {{ pageCount }}</span>
            </span>
            <button
                type="button"
                class="tiles__pagination-button"
                :aria-label="ariaLabelNextPage"
                :disabled="disableDown"
                @click="nextPage"
            >
                <svg-icon
                    original
                    name="icons/arrow-down"
                    class="tiles__pagination-icon"
                />
            </button>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

import tilesPagination from '../../../utils/mixins/tiles-pagination';
import aItemInfoWidth from '../../../utils/mixins/a-item-info-width';

export default {
    name: 'OTiles',
    mixins: [
        tilesPagination,
        aItemInfoWidth
    ],
    props: {
        items: {
            type: Array,
            default: () => []
        },
        itemsPerBlock: {
            type: Number,
            default: 0
        },
        value: {
            type: Object,
            default: () => {}
        },
        ariaLabelTitleButton: {
            type: String,
            default: 'Title button'
        },
        ariaLabelPrevPage: {
            type: String,
            default: 'Preview page'
        },
        ariaLabelNextPage: {
            type: String,
            default: 'NextPage'
        }
    },
    computed: {
        ...mapState({
            mapLoading: state => state.mapLoading
        }),
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    },
    methods: {
        onCLick(value) {
            this.localValue = value;
            this.$emit('tileClick', value);
        },
        swipeHandler(direction) {
            switch (direction) {
            case 'top':
                this.nextPage();
                break;
            case 'bottom':
                this.prevPage();
                break;
            default:
                break;
            }
        }
    },
    updated() {
        this.$nextTick(() => this.alignElements())
    },
    watch: {
        mapLoading() {
            this.$nextTick(() => this.alignElements())
        }
    }
}
</script>

<style lang="scss">
@import "o-tiles";
</style>
